class DealerCheckout extends HTMLElement { 
  constructor() {
    super();

    this.inputEl = this.querySelector('input[name="dealer_id"]');
    this.errorEl = this.querySelector('#dealer-error');
    this.validateButtonWrapper = this.querySelector('#cart-validate-button');
    this.submitWrapper = this.querySelector('#cart-submit');

    this.init();
  }

  init() {
    this.validateButtonWrapper.querySelector('button').addEventListener('click', async () => {
      await this.checkCode();
    });

    this.inputEl.addEventListener('keyup', async () => {
      await this.checkCode();
    });

    this.submitWrapper.querySelector('button').addEventListener('click', async() => {
      const attributes = [
        {
          name: 'Dealer-Location-ID',
          value: window.dealerData.dealer_code_id
        },
        {
          name: 'Dealer-Phone-Number',
          value: window.dealerData.phone
        },
        {
          name: 'Dealer-Location-Company',
          value: window.dealerData.company_name
        },
        {
          name: 'Dealer-Location-Address-Line-1',
          value: window.dealerData.address_line_1
        },
        {
          name: 'Dealer-Location-Address-Line-2',
          value: window.dealerData.address_line_2
        },
        {
          name: 'Dealer-Location-City',
          value: window.dealerData.city
        },
        {
          name: 'Dealer-Location-Postal-Code',
          value: window.dealerData.postcode
        },
        {
          name: 'Dealer-Location-Country',
          value: window.dealerData.country_code
        },
        {
          name: 'Dealer-Location-Province',
          value: window.dealerData.province_code
        }
      ];

      await this.updateCartAttributes(attributes);

      const params = new URLSearchParams({
        "checkout[shipping_address][company]":  window.dealerData.company_name,
        "checkout[shipping_address][address1]": window.dealerData.address_line_1,
        "checkout[shipping_address][address2]": window.dealerData.address_line_2,
        "checkout[shipping_address][city]":     window.dealerData.city,
        "checkout[shipping_address][country]":  window.dealerData.country_code,
        "checkout[shipping_address][zip]":      window.dealerData.postcode,
        "checkout[shipping_address][province]": window.dealerData.province_code,
        "checkout[shipping_address][phone]":    window.dealerData.phone
      });

      window.location = '/checkout?' + params.toString();

    });

    if(sessionStorage.getItem('ford_b2b_dealer_code')) {
      this.inputEl.value = sessionStorage.getItem('ford_b2b_dealer_code');
      const event = new Event('click');
      this.validateButtonWrapper.querySelector('button').dispatchEvent(event);
    }

    let hideSection = false;
    const productType = sessionStorage.getItem('b2b-access-allowed');
    const items = document.querySelectorAll('.product-type-error');

    for (let item of items) {
      if(productType !== item.getAttribute('data-product-type')) {
        item.style.display = '';
        hideSection = true;
      }
    }

    if(hideSection) {
      document.getElementById('dealer-checkout').style.display = 'none';
    }
  }

  async fetchDealer(text) {
    const response = await fetch('https://proddealerb2b.autonative.com/dealer-info/' + Shopify.shop + '/' + text);
    return await response.json();
  }

  async updateCartAttributes(attributes) {
    const formData = new FormData();

    for (let attribute of attributes) {
      formData.append("attributes[" + attribute.name + "]", attribute.value);
    }

    const response = await fetch(Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    });

    return await response.json();
  }

  async checkCode() {
    const text = this.inputEl.value;

    if (text.length) {
      const data = await this.fetchDealer(text);

      if (data.success) {
        window.dealerData = data.dealer;

        let html = data.dealer.company_name + '<br/>';
        html += data.dealer.address_line_1 + '<br/>';
        if (data.dealer.address_line_2) {
          html += data.dealer.address_line_2 + '<br/>';
        }
        html += data.dealer.city + '<br/>';
        html += data.dealer.postcode;

        this.submitWrapper.querySelector('.dealer-check').innerHTML = html;
        this.validateButtonWrapper.style.display = 'none';
        this.errorEl.style.display = 'none';
        this.submitWrapper.style.display = '';

        sessionStorage.setItem('ford_b2b_dealer_code', text);
      } else {
        sessionStorage.removeItem('ford_b2b_dealer_code');

        this.validateButtonWrapper.style.display = 'block';
        this.errorEl.style.display = 'block';
        this.submitWrapper.style.display = 'none';
      }
    }
  }
}

customElements.define('dealer-checkout', DealerCheckout);